// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2hUdm","head":"ProcedureTableInfo_head__3SbU3"};